module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "bar",
      rawName: "v-bar"
    }],
    staticClass: "scroll-wrap"
  }, [_c('div', {
    ref: "scrollBar",
    staticClass: "container",
    attrs: {
      "id": "scrollBar"
    },
    on: {
      "scroll": _vm.onScroll
    }
  }, [_c('div', {
    staticClass: "article-page",
    attrs: {
      "id": "article1"
    }
  }, [_c('div', {
    staticClass: "closer"
  }, [_c('route-item', {
    attrs: {
      "to": '/main',
      "element": 'main'
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaEvents('article1', 'click', 'go down')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "social-share social-block",
    class: {
      'open': _vm.openSocial
    }
  }, [(_vm.openSocial) ? _c('ul', {
    staticClass: "social-list"
  }, [_c('li', [_c('share-link', {
    staticClass: "icon",
    attrs: {
      "network": "fb",
      "url": "http://weleda.afisha.ru/share",
      "title": "Солнечная бодрость Сицилии",
      "image": "/static/img/share/share1.jpg",
      "description": "Сицилия — яркий и солнечный остров, омываемый тремя морями. Смотрите видео о том, как природа этого острова зовет к приключениям!",
      "article": "/article1"
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaEvents('article1', 'click', 'fb')
      }
    }
  }, [_c('fb')], 1)], 1), _vm._v(" "), _c('li', [_c('share-link', {
    staticClass: "icon",
    attrs: {
      "network": "vk",
      "url": "http://weleda.afisha.ru/share",
      "title": "Солнечная бодрость Сицилии",
      "image": "/static/img/share/share1.jpg",
      "description": "Сицилия — яркий и солнечный остров, омываемый тремя морями. Смотрите видео о том, как природа этого острова зовет к приключениям!",
      "article": "/article1"
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaEvents('article1', 'click', 'vk')
      }
    }
  }, [_c('vk')], 1)], 1), _vm._v(" "), _c('li', [_c('share-link', {
    staticClass: "icon",
    attrs: {
      "network": "ok",
      "url": "http://weleda.afisha.ru/share",
      "title": "Солнечная бодрость Сицилии",
      "image": "/static/img/share/share1.jpg",
      "description": "Сицилия — яркий и солнечный остров, омываемый тремя морями. Смотрите видео о том, как природа этого острова зовет к приключениям!",
      "article": "/article1"
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaEvents('article1', 'click', 'ok')
      }
    }
  }, [_c('ok')], 1)], 1), _vm._v(" "), _c('li', [_c('share-link', {
    staticClass: "icon",
    attrs: {
      "network": "tw",
      "url": "http://weleda.afisha.ru/share",
      "title": "Солнечная бодрость Сицилии",
      "image": "/static/img/share/share1.jpg",
      "description": "Сицилия — яркий и солнечный остров, омываемый тремя морями. Смотрите видео о том, как природа этого острова зовет к приключениям!",
      "article": "/article1"
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaEvents('article1', 'click', 'tw')
      }
    }
  }, [_c('tw')], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "open-social",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleSocial($event)
      }
    }
  }, [_c('p', [_vm._v("Поделиться")]), _vm._v(" "), _c('opensocial')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('h2', {
    staticClass: "head"
  }, [_vm._v("\n                    Солнечная бодрость Сицилии\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "video"
  }, [(!_vm.isPlaying) ? _c('div', {
    staticClass: "video-bg"
  }) : _vm._e(), _vm._v(" "), (!_vm.isPlaying) ? _c('div', {
    ref: "button",
    staticClass: "dplayer-bezel-icon",
    on: {
      "click": _vm.playVideo
    }
  }) : _vm._e(), _vm._v(" "), _c('youtube', {
    attrs: {
      "player-width": "560",
      "player-height": "315",
      "video-id": 'CAc8NdDXbKs',
      "player-vars": {
        autoplay: 0,
        controls: 0,
        showinfo: 0,
        rel: 0
      }
    },
    on: {
      "ready": _vm.ready,
      "ended": _vm.ended
    }
  })], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "slider"
  }, [_c('swiper', {
    ref: "slider",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_c('swiper-slide', [_c('div', {
    staticClass: "slide-content"
  }, [_c('img', {
    attrs: {
      "src": "static/img/article1/slides/slide1.jpg",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "slide-content"
  }, [_c('img', {
    attrs: {
      "src": "static/img/article1/slides/slide2.jpg",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "slide-content"
  }, [_c('img', {
    attrs: {
      "src": "static/img/article1/slides/slide3.jpg",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "slide-content"
  }, [_c('img', {
    attrs: {
      "src": "static/img/article1/slides/slide4.jpg",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "slide-content"
  }, [_c('img', {
    attrs: {
      "src": "static/img/article1/slides/slide5.jpg",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "slide-content"
  }, [_c('img', {
    attrs: {
      "src": "static/img/article1/slides/slide6.jpg",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "slide-content"
  }, [_c('img', {
    attrs: {
      "src": "static/img/article1/slides/slide7.jpg",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "slide-content"
  }, [_c('img', {
    attrs: {
      "src": "static/img/article1/slides/slide8.jpg",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "slide-content"
  }, [_c('img', {
    attrs: {
      "src": "static/img/article1/slides/slide9.jpg",
      "alt": ""
    }
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-prev custom-arrow-prev"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next custom-arrow-next"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "products-block mobile-hidden"
  }, [_c('div', {
    staticClass: "product-item"
  }, [_c('a', {
    staticClass: "link-item",
    attrs: {
      "href": "https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D1%86/%D1%86%D0%B8%D1%82%D1%80%D1%83%D1%81%D0%BE%D0%B2%D1%8B%D0%B9-%D0%BE%D1%81%D0%B2%D0%B5%D0%B6%D0%B0%D1%8E%D1%89%D0%B8%D0%B9-%D0%B3%D0%B5%D0%BB%D1%8C-%D0%B4%D0%BB%D1%8F-%D0%B4%D1%83%D1%88%D0%B0?utm_source=afisha&utm_medium=longread&utm_content=citrus_shower_gel&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.gaEvents('longread', 'click', '1-Массажное масло с арникой')
      }
    }
  }), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('span', {
    staticClass: "item-desc"
  }, [_vm._v("\n                            Гель смягчает кожу и сохраняет естественный баланс влаги\n                        ")]), _vm._v(" "), _vm._m(10)]), _vm._v(" "), _c('div', {
    staticClass: "product-item"
  }, [_c('a', {
    staticClass: "link-item",
    attrs: {
      "href": "https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D0%BC/%D0%BC%D0%B0%D1%81%D1%81%D0%B0%D0%B6%D0%BD%D0%BE%D0%B5-%D0%BC%D0%B0%D1%81%D0%BB%D0%BE-%D1%81-%D0%B0%D1%80%D0%BD%D0%B8%D0%BA%D0%BE%D0%B9?utm_source=afisha&utm_medium=longread&utm_content=arnica_massage_oil&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.gaEvents('longread', 'click', '2-Цитрусовый освежающий гель для душа')
      }
    }
  }), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('span', {
    staticClass: "item-desc"
  }, [_vm._v("\n                            Подготавливает мышцы к физическим нагрузкам, улучшает микроциркуляцию\n                        ")]), _vm._v(" "), _vm._m(13)]), _vm._v(" "), _c('div', {
    staticClass: "product-item"
  }, [_c('a', {
    staticClass: "link-item",
    attrs: {
      "href": "https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D1%86/%D1%86%D0%B8%D1%82%D1%80%D1%83%D1%81%D0%BE%D0%B2%D1%8B%D0%B9-%D0%B4%D0%B5%D0%B7%D0%BE%D0%B4%D0%BE%D1%80%D0%B0%D0%BD%D1%82-24-%D1%87%D0%B0%D1%81%D0%B0-roll-on?utm_source=afisha&utm_medium=longread&utm_content=citrus_deodorant_roll_on&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.gaEvents('longread', 'click', '3-Универсальный питательный крем SKIN FOOD')
      }
    }
  }), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _c('span', {
    staticClass: "item-desc"
  }, [_vm._v("\n                            Естественная свежесть и защита от неприятного запаха 24 часа\n                        ")]), _vm._v(" "), _vm._m(16)])]), _vm._v(" "), _c('div', {
    ref: "products",
    staticClass: "products-block desktop-hidden"
  }, [_c('swiper', {
    attrs: {
      "options": _vm.swiperProductOption
    }
  }, [_c('swiper-slide', [_c('div', {
    staticClass: "product-item"
  }, [_c('a', {
    staticClass: "link-item",
    attrs: {
      "href": "https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D1%86/%D1%86%D0%B8%D1%82%D1%80%D1%83%D1%81%D0%BE%D0%B2%D1%8B%D0%B9-%D0%BE%D1%81%D0%B2%D0%B5%D0%B6%D0%B0%D1%8E%D1%89%D0%B8%D0%B9-%D0%B3%D0%B5%D0%BB%D1%8C-%D0%B4%D0%BB%D1%8F-%D0%B4%D1%83%D1%88%D0%B0?utm_source=afisha&utm_medium=longread&utm_content=citrus_shower_gel&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.gaEvents('longread', 'click', '1-Массажное масло с арникой')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": "static/img/product/product1.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "item-head"
  }, [_vm._v("\n                                    Цитрусовый "), _c('br'), _vm._v("освежающий гель"), _c('br'), _vm._v(" для душа\n                                ")]), _vm._v(" "), _c('span', {
    staticClass: "item-desc"
  }, [_vm._v("\n                                    Гель смягчает кожу и сохраняет естественный баланс влаги\n                                ")]), _vm._v(" "), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D1%86/%D1%86%D0%B8%D1%82%D1%80%D1%83%D1%81%D0%BE%D0%B2%D1%8B%D0%B9-%D0%BE%D1%81%D0%B2%D0%B5%D0%B6%D0%B0%D1%8E%D1%89%D0%B8%D0%B9-%D0%B3%D0%B5%D0%BB%D1%8C-%D0%B4%D0%BB%D1%8F-%D0%B4%D1%83%D1%88%D0%B0?utm_source=afisha&utm_medium=longread&utm_content=citrus_shower_gel&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                                Подробнее\n                            ")])])])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "product-item"
  }, [_c('a', {
    staticClass: "link-item",
    attrs: {
      "href": "https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D0%BC/%D0%BC%D0%B0%D1%81%D1%81%D0%B0%D0%B6%D0%BD%D0%BE%D0%B5-%D0%BC%D0%B0%D1%81%D0%BB%D0%BE-%D1%81-%D0%B0%D1%80%D0%BD%D0%B8%D0%BA%D0%BE%D0%B9?utm_source=afisha&utm_medium=longread&utm_content=arnica_massage_oil&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.gaEvents('longread', 'click', '2-Цитрусовый освежающий гель для душа')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": "static/img/product/product2.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "item-head"
  }, [_vm._v("\n                                    Массажное "), _c('br'), _vm._v("масло с арникой\n                                ")]), _vm._v(" "), _c('span', {
    staticClass: "item-desc"
  }, [_vm._v("\n                                    Подготавливает мышцы к физическим нагрузкам, улучшает микроциркуляцию\n                                ")]), _vm._v(" "), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D0%BC/%D0%BC%D0%B0%D1%81%D1%81%D0%B0%D0%B6%D0%BD%D0%BE%D0%B5-%D0%BC%D0%B0%D1%81%D0%BB%D0%BE-%D1%81-%D0%B0%D1%80%D0%BD%D0%B8%D0%BA%D0%BE%D0%B9?utm_source=afisha&utm_medium=longread&utm_content=arnica_massage_oil&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                                        Подробнее\n                                    ")])])])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "product-item"
  }, [_c('a', {
    staticClass: "link-item",
    attrs: {
      "href": "https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D1%86/%D1%86%D0%B8%D1%82%D1%80%D1%83%D1%81%D0%BE%D0%B2%D1%8B%D0%B9-%D0%B4%D0%B5%D0%B7%D0%BE%D0%B4%D0%BE%D1%80%D0%B0%D0%BD%D1%82-24-%D1%87%D0%B0%D1%81%D0%B0-roll-on?utm_source=afisha&utm_medium=longread&utm_content=citrus_deodorant_roll_on&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.gaEvents('longread', 'click', '3-Универсальный питательный крем SKIN FOOD')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": "static/img/product/product3.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "item-head"
  }, [_vm._v("\n                                    Цитрусовый "), _c('br'), _vm._v(" дезодорант\n                                ")]), _vm._v(" "), _c('span', {
    staticClass: "item-desc"
  }, [_vm._v("\n                                    Естественная свежесть и защита от неприятного запаха 24 часа\n                                ")]), _vm._v(" "), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D1%86/%D1%86%D0%B8%D1%82%D1%80%D1%83%D1%81%D0%BE%D0%B2%D1%8B%D0%B9-%D0%B4%D0%B5%D0%B7%D0%BE%D0%B4%D0%BE%D1%80%D0%B0%D0%BD%D1%82-24-%D1%87%D0%B0%D1%81%D0%B0-roll-on?utm_source=afisha&utm_medium=longread&utm_content=citrus_deodorant_roll_on&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                                        Подробнее\n                                    ")])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination"
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "check"
  }, [_vm._m(17), _vm._v(" "), _c('router-link', {
    staticClass: "btn",
    attrs: {
      "to": "/article2"
    },
    nativeOn: {
      "click": function($event) {
        _vm.$root.gaSend('main', 'click', 'go to longread 2')
      }
    }
  }, [_vm._v("\n                    Далее\n                ")])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "quotes"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("В каждое путешествие я собираюсь с чувством, что меня ждет что-то новое и интересное. Вот и на этот раз поездка получилась насыщенной и познавательной")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("\n                        Сицилия — яркий и солнечный остров, омываемый тремя морями. Здесь природа дает человеку все\n                        возможности для выращивания разнообразных фруктов, часть которых затем превращается в\n                        прекрасные косметические продукты.\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        Бирюзовое море и сизые макушки вулканов, древние руины и прекрасно сохранившиеся палаццо,\n                        терпкие лимоны — острову, вставшему на якорь у мыска итальянского сапога, есть что\n                        предложить любителям контрастов.\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        Самая важная достопримечательность Сицилии, которую можно увидеть практически отовсюду, —\n                        Этна, высочайшая гора южной Италии и главный действующий вулкан Европы.\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        Этна считается неопасной — настолько, что на ее склонах выращивают фрукты и разбивают\n                        виноградники, но сицилийцы с нежностью зовут ее la diva, «дивой», капризной оперной звездой,\n                        которая выступает тогда, когда этого меньше всего ждешь.\n                    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "quotes"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                        Подъем на вершину вулкана Этна и открывающиеся оттуда пейзажи — это одно из самых сильных впечатлений от моего итальянского путешествия. Если вы планируете подняться на Этну, то советую взять с собой теплые вещи — на вершине лежит снег. Из косметики могу посоветовать Skin Food от Weleda, отличный питательный крем на все случаи, от обветривания и после солнца, питает, защищает и увлажняет\n                    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("\n                        Подняться к кратеру вулкана можно разными способами; большинство маршрутов пролегает по\n                        южному склону с его «марсианскими» пейзажами — серебристым песком, фумаролами и красивыми\n                        образованиями из зеленоватых кристаллов серы, которые вырастают в тех местах, где газ\n                        вырывается из трещин в земле.\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        Есть мнение, что воздух вулкана полезен для здоровья, — в это верят все сицилийцы, как\n                        прежде верили в то, что в кратере Этны есть вход в подземное царство Плутона.\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        Когда говорят, что Сицилия — вулканический остров, имеют в виду не только его геологические\n                        особенности: правда в том, что на протяжении нескольких тысяч лет в пламени Этны закалялись\n                        сицилийские пейзажи, кухня и даже культура.\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        Взять хотя бы знаменитое сицилийское барокко — уникальный архитектурный стиль, который\n                        отличают особая пышность и необычные формы, напоминающие языки пламени.\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        Его появлению предшествовало мощное извержение Этны и землетрясение 1693 года, позже\n                        названное Большим Сицилийским: мощные толчки сровняли юго-восток острова с землей, и многие\n                        города пришлось отстраивать заново — из вулканического камня.\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        Так и появились архитектурные шедевры, которыми теперь славится долина Валь-ди-Ното — ее\n                        соборы, церкви и палаццо особенно красивы с наступлением темноты, когда эффектно\n                        подсвечиваются прожекторами.\n                    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "quotes"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                       Солнечная Сицилия подарила мне редкую возможность полного слияния с природой. Очень красивый и разнообразный остров, омываемый тремя морями (Средиземным, Ионическим и Тирренским), непревзойденные пляжи, мысы, горы и, конечно, ароматные цитрусовые сады\n                   ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("\n                        Сицилийскую кухню, в отличие от городков Валь-ди-Ното, пока не включили в Список всемирного\n                        наследия ЮНЕСКО, но она тоже совершенно «вулканическая» — cibo vulcanico, как ее называют\n                        местные шефы.\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        Окружающие Этну почвы особенно богаты минеральными солями, и виноград, фрукты и овощи здесь\n                        рождаются с особенным соотношением сахара и кислоты.\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        Некоторые местные продукты даже имеют особенный знак качества, DOP — это и оливковое масло\n                        Monte Etna, и местная опунция, и зеленая фисташка.\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        А сицилийские лимоны украшают большинство итальянских блюд: из них делают сорбеты, соусы к\n                        пасте и рыбным блюдам, их используют в качестве пряности и даже натурального консерванта —\n                        лимонный сок уплотняет нежную консистенцию рыбы и морепродуктов.\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        Кроме того, эфирные масла в составе лимона превращают его в кладезь ценных косметических\n                        свойств, которые Weleda из года в год использует в своей продукции. Все цитрусовые, входящие\n                        в состав средств по уходу за телом, выращены в биодинамических хозяйствах — без пестицидов,\n                        гербицидов и других химикатов, зато в соответствии с естественными циклами биологической\n                        энергии.\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        А еще на этом чудо-острове совершенно невероятный воздух, напоенный ароматами моря, лимонов\n                        и леса. Редкое, практически гастрономическое сочетание, ради которого на Сицилию приезжают\n                        миллионы людей каждый год.\n                    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "quotes"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                       На Сицилии я посетила знаменитые лимонные сады и узнала о сырье для производства цитрусовой линейки натуральной косметики Weleda. Кстати, сицилийские лимоны показались мне менее кислыми и более ароматными, чем те, к которым мы привыкли дома\n                   ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img-content"
  }, [_c('div', {
    staticClass: "img"
  }, [_c('img', {
    staticClass: "img1",
    attrs: {
      "src": "static/img/article1/inner-img1.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_c('p', [_vm._v("\n                            Но если хотите успеть насладиться сицилийской едой, природой и ароматом лимонов —\n                            поспешите: остров неумолимо движется по направлению к материковой Италии, собираясь\n                            подмять Липарские острова. Словом, у вас в запасе не более пары миллионов лет.\n                        ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": "static/img/product/product1.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "item-head"
  }, [_vm._v("\n                            Цитрусовый "), _c('br'), _vm._v("освежающий гель"), _c('br'), _vm._v(" для душа\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "link",
    attrs: {
      "href": "https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D1%86/%D1%86%D0%B8%D1%82%D1%80%D1%83%D1%81%D0%BE%D0%B2%D1%8B%D0%B9-%D0%BE%D1%81%D0%B2%D0%B5%D0%B6%D0%B0%D1%8E%D1%89%D0%B8%D0%B9-%D0%B3%D0%B5%D0%BB%D1%8C-%D0%B4%D0%BB%D1%8F-%D0%B4%D1%83%D1%88%D0%B0?utm_source=afisha&utm_medium=longread&utm_content=citrus_shower_gel&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                                Подробнее\n                            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": "static/img/product/product2.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "item-head"
  }, [_vm._v("\n                            Массажное "), _c('br'), _vm._v("масло с арникой\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "link",
    attrs: {
      "href": "https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D0%BC/%D0%BC%D0%B0%D1%81%D1%81%D0%B0%D0%B6%D0%BD%D0%BE%D0%B5-%D0%BC%D0%B0%D1%81%D0%BB%D0%BE-%D1%81-%D0%B0%D1%80%D0%BD%D0%B8%D0%BA%D0%BE%D0%B9?utm_source=afisha&utm_medium=longread&utm_content=arnica_massage_oil&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                                Подробнее\n                            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": "static/img/product/product3.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "item-head"
  }, [_vm._v("\n                            Цитрусовый "), _c('br'), _vm._v(" дезодорант\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "link",
    attrs: {
      "href": "https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D1%86/%D1%86%D0%B8%D1%82%D1%80%D1%83%D1%81%D0%BE%D0%B2%D1%8B%D0%B9-%D0%B4%D0%B5%D0%B7%D0%BE%D0%B4%D0%BE%D1%80%D0%B0%D0%BD%D1%82-24-%D1%87%D0%B0%D1%81%D0%B0-roll-on?utm_source=afisha&utm_medium=longread&utm_content=citrus_deodorant_roll_on&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                                Подробнее\n                            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footnote"
  }, [_c('p', [_vm._v("*Веледа,ДОП,Монте этна,Ролл-он")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e4eed748","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/articles/article1.vue
// module id = 555
// module chunks = 1